import { isBlurhashValid } from 'blurhash'

export interface BlurhashAttachmentFields {
  blurhash?: string
  blurhashCode?: string
}

/** Returns true when the string is a well-formed BlurHash from backend attachment metadata. */
export function isValidBlurhash(hash: string | undefined | null): boolean {
  if (!hash) return false
  return isBlurhashValid(hash).result
}

/** Resolves blurhash from attachment metadata, preferring `blurhash` over legacy `blurhashCode`. */
export function getBlurhash(attachment: BlurhashAttachmentFields | null | undefined): string {
  if (!attachment) return ''
  return attachment.blurhash || attachment.blurhashCode || ''
}
